import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * Shows the CISE/VIGIMARE XML behind a message, so an operator can see the exact
 * structure that was exchanged rather than only the rendered summary.
 */
@Component({
  selector: 'app-xml-spotlight',
  standalone: true,
  imports: [],
  templateUrl: './xml-spotlight.html',
  styleUrl: './xml-spotlight.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XmlSpotlightComponent {
  title = input.required<string>();
  subtitle = input<string | null>(null);
  xml = input<string | null>(null);
  loading = input(false);
  error = input<string | null>(null);

  closed = output<void>();
}
